// onload of document trigger function
$(document).ready(function () {
  if (zipcode == "") {
    console.log("no zipcode");
    $("#cta_order_by").hide();
  } else {
    console.log("fast geo zip " + zipcode);
    $("#enterzipcode").val(zipcode);
    $(".zip_button").trigger("click");
  }
});